<template>
<div>
  <b-navbar class="navbar navbar-expand-lg justify-content-between" variant="faded" type="light">
    <b-navbar-brand href="/">
      <img src="../assets/LIFTlogo.png" class="d-inline-block align-center" width="40" height="40" /> KOCH LIFT AR Laboratory
    </b-navbar-brand>
      <ul>
        <b-button class="d-none d-md-block" id="show-btn" @click="showModal" block variant="light">
          <b-iconstack font-scale="1.5"><b-icon stacked icon="camera" animation="throb" variant="dark" scale="1.25"></b-icon></b-iconstack>
          Mobile QR Code
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="blue" class="bi bi-upc-scan" viewBox="0 0 16 16">
            <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>
          </svg>
        </b-button>
        <b-modal ref="my-modal" hide-footer title="Scan with your mobile device">
          <li><a href="https://support.apple.com/en-us/HT208843" target="_blank" ><b>How to :</b> Apple - iPhone, iPad, iPod</a></li>
          <li><a href="https://www.tomsguide.com/how-to/how-to-scan-a-qr-code-on-android" target="_blank"><b>How to :</b> Android devices</a></li>
          <div class="d-block text-center">
              <br>
              <img src="../assets/LIFTQRCode.png" width="200" height="200">
          </div>
          <br>
          <b-button class="mt-3" variant="outline-dark" block @click="hideModal">Close</b-button>
        </b-modal>
      </ul>
  </b-navbar>
</div>
</template>


<script>
export default {
  name: 'NavBar',
  methods: {
    // MODAL - QR Code
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
  }
};
</script>

<style scoped>

  b {
    color: #295E96;
    font-size: 18px;
  }

</style>
